export interface ClinicInvoice {
 id:string;clinic_id:string;encounter_id:string;patient_id:string;total_kobo:number;paid_kobo:number;
 payments?:Array<{reference:string;method:string;amount_kobo:number;unallocated_kobo:number;paid_at:string;settlement_status:string}>;
 attempts?:Array<{reference:string;status:string;amount_kobo:number;created_at:string}>;
 status:'issued'|'part_paid'|'paid'|'cancelled';mode:'test';currency:'NGN';created_at:string;expires_at:string;payment_url:string;
}
export interface ClinicPaymentSetup {
 mode:'test';connected:boolean;ready:boolean;status:'pending'|'test_ready';bank_name:string|null;account_name:string|null;account_last4:string|null;commission_kobo:0;fee_bearer:'clinic';
}
export interface PatientBillResponse {
 invoice:{id:string;clinic_name:string;total_kobo:number;paid_kobo:number;balance_kobo:number;status:ClinicInvoice['status'];mode:'test';currency:'NGN';created_at:string};
 items:Array<{amount_kobo:number;service_type:string}>;
 payments:Array<{reference:string;method:string;amount_kobo:number;allocated_kobo:number;unallocated_kobo:number;refunded_kobo?:number;paid_at:string;settlement_status:string}>;
 attempts:Array<{reference:string;status:string;amount_kobo:number;created_at:string}>;
 checkout_ready:boolean;
}
export function nairaInputToKobo(value:string):number|null {
 if(!/^\d+(\.\d{1,2})?$/.test(value.trim()))return null;
 const [whole,part='']=value.trim().split('.');const amount=Number(whole)*100+Number(part.padEnd(2,'0'));
 return Number.isSafeInteger(amount)&&amount>0&&amount<=2147483647?amount:null;
}
